import React from 'react'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import {
  CloseModalOnPipe,
  ExecuteOperationOnPipe,
  Form,
  OpenModalOnPipe,
  Operation,
  useValue
} from '@morningtrain/react-resources'
import Modal from 'widgets/modals/Modal'
import { SubmitButton } from 'ui/buttons'
import { ResourceSelector } from 'support/fields'
import { StaticFilter } from '@morningtrain/react-filters'
import { CanUseModel } from '@morningtrain/react-auth'

export default function CreateFromTemplate () {
  const category = useValue('category')
  const modalRef = React.useRef()
  let _resolve = null

  const _reject = React.useRef()

  const handleClose = (err) => {
    if (_reject.current !== null) {
      _reject.current(err)
    }
  }

  const handleOnSubmit = (data) => {
    if (_resolve !== null) {
      _resolve(data)
    }
  }

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      _resolve = data => {
        payload.data = data
        resolve(data)
      }
      _reject.current = (err) => {
        reject(err)
      }
    })
  }

  return (
    <CanUseModel permission='api.shifts.schedule.populate_from_template'>
      <Modal ref={modalRef} handleClose={handleClose}>
        <Operation namespace='api' resourceName='shifts.schedule' operationName='populate_from_template'>
          <Form onSubmit={handleOnSubmit} submitTo='populate_from_template'>
            <div className='flex flex-col space-y-4'>
              <ResourceSelector
                menuPortalTarget={document.body}
                name='template_schedule_id'
                optionsKey='select_name'
                resourceName='shifts.schedule'
                operationName='select'
                label={<Translation name='fields.template_week.label' />}
              >
                <StaticFilter name='category' value={category} />
              </ResourceSelector>
              <SubmitButton>
                <Translation name='generic.create' />
              </SubmitButton>
            </div>
          </Form>
        </Operation>
      </Modal>
      <Pipeline>
        <TriggerPipelineOnClick>
          <Button>
            <Translation name='generic.populate_from_template' defaultValue='Create from template' />
          </Button>
        </TriggerPipelineOnClick>
        <OpenModalOnPipe modalRef={modalRef} />
        <CallbackOnPipe callback={handleOnPipe} />
        <CloseModalOnPipe modalRef={modalRef} />
        <ExecuteOperationOnPipe operationName='fetch' />
        <ExecuteOperationOnPipe resourceName='shifts.schedule_slot' operationName='grouped_by_day' />
      </Pipeline>
    </CanUseModel>
  )
}
